// Gravity signups created from this date on wait for `signupCompanyStatus` before
// the signup webhook fires (API `sendSignupWebhook`). Older accounts never had
// that gate, so they must not be reported as new signups now.
const DEFERRED_GRAVITY_SIGNUP_WEBHOOK_SINCE = Date.parse('2026-07-24T00:00:00Z');
const SIGNUP_ROUTE_PATTERN = /^\/(signup|login|sso-callback)(\/|$)|callback/;

// A Gravity user can reach the app without the onboarding finish step running
// (reload mid-onboarding, leaving /signup, or the signup screen's companyId
// redirect), which left `signupCompanyStatus` unset and dropped the signup
// webhook for good. Being in the app with a company is the completion.
const shouldCompleteSkippedGravitySignup = ({ user, pathname, isSignUpComplete, hasCompanies, hasRunSignUpFinish } = {}) => {
  const unsafeMetadata = user?.unsafeMetadata || {};
  const createdAt = new Date(user?.createdAt || 0).getTime();

  return (
    unsafeMetadata.signup_source === 'gravity' &&
    unsafeMetadata.signupCompanyStatus !== 'complete' &&
    Boolean(user?.publicMetadata?.companyId) &&
    hasCompanies === true &&
    // PostSignUpHandler owns the normal finish: before it runs `isComplete` is
    // set, and once it ran, `finishSignUp` clears that state before its own
    // Clerk update lands.
    isSignUpComplete !== true &&
    hasRunSignUpFinish !== true &&
    !SIGNUP_ROUTE_PATTERN.test(pathname || '') &&
    createdAt >= DEFERRED_GRAVITY_SIGNUP_WEBHOOK_SINCE
  );
};

export default shouldCompleteSkippedGravitySignup;
